import { cn } from '../../lib/utils.js';

export const Skeleton = ({ className }) => (
  <div className={cn('shimmer-bg rounded-2xl', className)} />
);

export const ReceiptItemSkeleton = () => (
  <div className="glass rounded-2xl p-4 flex items-center gap-3">
    <Skeleton className="w-10 h-10 rounded-xl flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <Skeleton className="h-3.5 w-2/3" />
      <Skeleton className="h-3 w-1/3" />
    </div>
    <Skeleton className="h-5 w-14" />
  </div>
);

export const ParticipantSkeleton = () => (
  <div className="glass rounded-2xl p-4 flex items-center gap-3">
    <Skeleton className="w-10 h-10 rounded-full flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <Skeleton className="h-3.5 w-24" />
      <Skeleton className="h-3 w-16" />
    </div>
    <Skeleton className="h-6 w-16" />
  </div>
);
